export default __webpack_public_path__ + "static/media/330_store01-it-mobile.57380ce5.png";